import { render, staticRenderFns } from "./YoutubePopUp.vue?vue&type=template&id=05bf5244&scoped=true&"
import script from "./YoutubePopUp.vue?vue&type=script&lang=js&"
export * from "./YoutubePopUp.vue?vue&type=script&lang=js&"
import style0 from "./YoutubePopUp.vue?vue&type=style&index=0&id=05bf5244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf5244",
  null
  
)

export default component.exports